'use client';

/**
 * Top-level lobby shell with the Skillz brand header and content area.
 */

import {useEffect} from 'react';
import Image from 'next/image';
import Link from 'next/link';
import {useSearchParams} from 'next/navigation';
import skillzLogo from '@/../public/skillzLogo.svg';
import skillzWordmark from '@/../public/skillz_wordmark_white.svg';
import {trackArcadeEvent, ARCADE_EVENT} from './trackArcadeEvent';

interface LobbyLayoutProps {
  children: React.ReactNode;
}

const LobbyLayout = ({children}: LobbyLayoutProps) => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const source = searchParams.get('ref') === 'arcade_header' ? 'arcade_header' : 'direct';
    trackArcadeEvent(ARCADE_EVENT.LOBBY_VIEW, {result: JSON.stringify({source})});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='min-h-screen bg-white dark:bg-black'>
      <header
        className='
          sticky top-0 z-10
          flex w-full items-center justify-center
          bg-primary-dark px-4 py-3
          shadow-md
          sm:py-4
        '
      >
        <Link
          href='/'
          aria-label='Skillz Arcade home'
          className='flex items-center gap-2 outline-none focus-visible:ring-2 focus-visible:ring-primary-blue rounded-md'
        >
          <Image src={skillzLogo} alt='Skillz' priority className='h-7 w-7 sm:h-8 sm:w-8' />
          <Image src={skillzWordmark} alt='' aria-hidden priority className='h-5 w-auto sm:h-6' />
        </Link>
      </header>
      <main>{children}</main>
    </div>
  );
};

export default LobbyLayout;
